var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("h1", { staticClass: "el-name" }, [
        _vm._v("\n            " + _vm._s(this.arResult.NAME) + "\n        "),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "stars" },
        [
          _c("v-rating", {
            attrs: {
              readonly: "",
              length: "5",
              color: "yellow darken-3",
              "background-color": "grey darken-1",
              value: parseInt(_vm.arResult.RATING),
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "count-feed" }, [
            _vm._v("(" + _vm._s(_vm.getCountFeed(_vm.arResult)) + ")"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "fl-cont-cont" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xl-9", attrs: { div: "" } }, [
            _vm.arResult
              ? _c("div", { staticClass: "row mar-b-cont" }, [
                  _c("div", { staticClass: "col-xl-8 cor-st" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-xl-3" },
                        [
                          _vm.arResult.GALLERY.SMALL.length > 4
                            ? _c(
                                "div",
                                {
                                  staticClass: "prev-vert-arrow",
                                  on: { click: _vm.goPrevSlide },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "11",
                                        height: "20",
                                        viewBox: "0 0 11 20",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z",
                                          fill: "currentColor",
                                          "transform-origin": "center",
                                          transform: "rotate(180)",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "swiper-container",
                            {
                              ref: "swiper2",
                              staticClass: "swiper-2",
                              attrs: {
                                "slides-per-view": 4,
                                loop: false,
                                direction: "vertical",
                                navigation: false,
                              },
                            },
                            _vm._l(
                              _vm.arResult.GALLERY.SMALL,
                              function (image, index) {
                                return _c("swiper-slide", { key: index }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "story-carousel__slide cp-slide",
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: image.src,
                                          alt: "",
                                          width: image.width,
                                          height: image.height,
                                          loading: "lazy",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass: "swiper-lazy-preloader",
                                      }),
                                    ]
                                  ),
                                ])
                              }
                            ),
                            1
                          ),
                          _vm._v(" "),
                          _vm.arResult.GALLERY.SMALL.length > 4
                            ? _c(
                                "div",
                                {
                                  staticClass: "next-vert-arrow",
                                  on: { click: _vm.goNextSlide },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "11",
                                        height: "20",
                                        viewBox: "0 0 11 20",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z",
                                          fill: "currentColor",
                                          "transform-origin": "center",
                                          transform: "rotate(180)",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xl-9" }, [
                        _c(
                          "div",
                          { staticClass: "relative" },
                          [
                            _vm._l(_vm.arResult.ACTIONS, function (ACTION) {
                              return _vm.arResult.ACTIONS
                                ? _c("div", { staticClass: "actions" }, [
                                    ACTION.VALUE == "3547"
                                      ? _c("div", {
                                          staticClass:
                                            "item-promo-popular-peop",
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    ACTION.VALUE == "3546"
                                      ? _c("div", {
                                          staticClass: "item-promo-akcii",
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    ACTION.VALUE == "3545"
                                      ? _c("div", {
                                          staticClass: "item-promo-new",
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    ACTION.VALUE == "3548"
                                      ? _c("div", {
                                          staticClass: "item-promo-xit",
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    ACTION.VALUE == "3549"
                                      ? _c("div", {
                                          staticClass: "item-promo-rent-i",
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    ACTION.VALUE == "6070"
                                      ? _c("div", {
                                          staticClass: "item-promo-del-i",
                                        })
                                      : _vm._e(),
                                  ])
                                : _vm._e()
                            }),
                            _vm._v(" "),
                            _c(
                              "swiper-container",
                              {
                                staticClass: "swiper-1",
                                attrs: {
                                  "slides-per-view": 1,
                                  loop: true,
                                  navigation: "true",
                                  "thumbs-swiper": ".swiper-2",
                                  effect: "fade",
                                },
                              },
                              _vm._l(
                                _vm.arResult.GALLERY.LARGE,
                                function (image, index) {
                                  return _c("swiper-slide", { key: index }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "cen-fl-img",
                                        attrs: {
                                          href: _vm.arResult.GALLERY.ORIGINAL[
                                            index
                                          ].src,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            $event.preventDefault()
                                            return _vm.showFancy(index)
                                          },
                                        },
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: image.src,
                                            alt: "",
                                            width: image.width,
                                            height: image.height,
                                            loading: "lazy",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "swiper-lazy-preloader",
                                        }),
                                      ]
                                    ),
                                  ])
                                }
                              ),
                              1
                            ),
                          ],
                          2
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-xl-4" }, [
                    _c("div", { staticClass: "shop-one" }, [
                      _vm.arResult.PROPS.CML2_ARTICLE
                        ? _c("div", { staticClass: "article" }, [
                            _vm._v(
                              "\n                                    Артикул: " +
                                _vm._s(
                                  _vm.arResult.PROPS.CML2_ARTICLE[0].VALUE
                                ) +
                                "\n                                "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "counter" }, [
                        _vm._v(
                          "\n                                    " +
                            _vm._s(_vm.arResult.SHOW_COUNTER) +
                            " просмотров товара за 2 месяца\n                                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "po-desc" }, [
                        _c("span", { staticClass: "po-desc-h" }, [
                          _vm._v("Дополнительная информация"),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "ul",
                            _vm._l(_vm.arResult.PROPS, function (item) {
                              return _c("li", [
                                _c("span", { staticClass: "name" }, [
                                  _vm._v(_vm._s(item[0].NAME) + ":"),
                                ]),
                                _vm._v(" "),
                                item[0].VALUE_TEXT
                                  ? _c("span", [
                                      _vm._v(_vm._s(item[0].VALUE_TEXT)),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                !item[0].VALUE_TEXT
                                  ? _c("span", [_vm._v(_vm._s(item[0].VALUE))])
                                  : _vm._e(),
                              ])
                            }),
                            0
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "all-scr-char",
                          attrs: { href: "" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.scrollToChar.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v("Все характеристики")]
                      ),
                      _vm._v(" "),
                      _vm.arResult.OFFERS
                        ? _c(
                            "div",
                            { staticClass: "offers" },
                            _vm._l(
                              _vm.arResult.OFFERS.PROPS,
                              function (prop, name) {
                                return _c("div", { staticClass: "props" }, [
                                  _c("label", { attrs: { for: "" } }, [
                                    _vm._v(_vm._s(name) + ":"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "select" }, [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.activeOffer,
                                            expression: "activeOffer",
                                          },
                                        ],
                                        attrs: { name: "offers", id: "offers" },
                                        on: {
                                          change: [
                                            function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.activeOffer = $event.target
                                                .multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            },
                                            _vm.changeOffer,
                                          ],
                                        },
                                      },
                                      _vm._l(prop, function (val, index) {
                                        return _c(
                                          "option",
                                          {
                                            domProps: {
                                              value: val.ID,
                                              selected:
                                                val.ID == _vm.activeOffer,
                                            },
                                          },
                                          [_vm._v(_vm._s(val.VALUE))]
                                        )
                                      }),
                                      0
                                    ),
                                  ]),
                                ])
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.arResult.CUSTOM_OFFERS.length > 1
                        ? _c("div", { staticClass: "block-v" }, [
                            _c("label", { staticClass: "label-variants" }, [
                              _vm._v(
                                "Варианты исполнения (" +
                                  _vm._s(_vm.arResult.CUSTOM_OFFERS.length) +
                                  "):"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "block-variants" }, [
                              _vm.arResult.CUSTOM_OFFERS
                                ? _c(
                                    "div",
                                    { staticClass: "link-variant" },
                                    _vm._l(
                                      _vm.arResult.CUSTOM_OFFERS,
                                      function (offer, index) {
                                        return _c(
                                          "a",
                                          {
                                            class: { active: index == 0 },
                                            attrs: {
                                              href: offer.DETAIL_PAGE_URL,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                                " +
                                                _vm._s(
                                                  offer.PROPS.OFFER_NAME
                                                    ? offer.PROPS.OFFER_NAME[0]
                                                        .VALUE
                                                    : offer.NAME
                                                ) +
                                                "\n                                            "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "delivery-msk" }, [
                        _vm._v(
                          "\n                                        Доставка по Москве "
                        ),
                        _vm.arResult.PROPS.DELIVERY
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.arResult.PROPS.DELIVERY[0].VALUE_TEXT
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(
                          "\n                                        Доставка по всей России "
                        ),
                        _c("span", [_vm._v("от 3 до 5 дней")]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "delivery-msk" }),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-xl-12" },
                [
                  _c(
                    "v-tabs",
                    {
                      staticClass: "tab-disc-cont",
                      attrs: { "align-with-title": "" },
                      model: {
                        value: _vm.tab,
                        callback: function ($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab",
                      },
                    },
                    [
                      _c("v-tab", { staticClass: "des psn-rel-disc" }, [
                        _vm._v(
                          "\n                                Описание\n                            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-tab", [
                        _vm._v(
                          "\n                                Характеристики\n                            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-tab", {
                        domProps: {
                          innerHTML: _vm._s(
                            "Отзывы с нашего магазина на OZON(" +
                              _vm.arResult.COUNT_FEEDBACKS +
                              ")"
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("v-tab", [
                        _vm._v(
                          "\n                                Инструкции\n                            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-tab", [
                        _vm._v(
                          "\n                                Вопрос ответ (" +
                            _vm._s(_vm.arResult.COUNT_QUICKS) +
                            ")\n                            "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tabs-items",
                    {
                      model: {
                        value: _vm.tab,
                        callback: function ($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab",
                      },
                    },
                    [
                      _c(
                        "v-tab-item",
                        { attrs: { transition: "fade-transition" } },
                        [
                          _c("v-lazy", [
                            _c("div", [
                              _c("div", {
                                staticClass: "hide-disc",
                                class: { viewDisc: _vm.activeDescr },
                                domProps: {
                                  innerHTML: _vm._s(_vm.arResult.DETAIL_TEXT),
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "hide-disc-b" }, [
                                !_vm.activeDescr
                                  ? _c(
                                      "span",
                                      {
                                        attrs: { id: "hide-disc-b-js" },
                                        on: { click: _vm.showDisc },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                                    Развернуть\n                                                "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.activeDescr
                                  ? _c(
                                      "span",
                                      {
                                        attrs: { id: "hide-disc-b-js" },
                                        on: { click: _vm.showDisc },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                                    Свернуть\n                                                "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        { attrs: { transition: "fade-transition" } },
                        [
                          _c("v-lazy", [
                            _c(
                              "ul",
                              { staticClass: "char-tab-td" },
                              _vm._l(_vm.arResult.PROPS, function (item) {
                                return _c("li", [
                                  _c("span", { staticClass: "name" }, [
                                    _vm._v(_vm._s(item[0].NAME) + ":"),
                                  ]),
                                  _vm._v(" "),
                                  item[0].VALUE_TEXT
                                    ? _c("span", [
                                        _vm._v(_vm._s(item[0].VALUE_TEXT)),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !item[0].VALUE_TEXT
                                    ? _c("span", [
                                        _vm._v(_vm._s(item[0].VALUE)),
                                      ])
                                    : _vm._e(),
                                ])
                              }),
                              0
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        { attrs: { transition: "fade-transition" } },
                        [
                          _c("v-lazy", [
                            _vm.arResult.FEEDBACKS && _vm.tab == "2"
                              ? _c(
                                  "div",
                                  [
                                    _c("feedbacks-card", {
                                      attrs: {
                                        "signed-parameters":
                                          _vm.ajaxParams.signedParameters,
                                        token: _vm.ajaxParams.token,
                                        id: this.originalId,
                                        "avg-rating": _vm.arResult.RATING,
                                        "count-feeds": _vm.getCountFeed(
                                          _vm.arResult
                                        ),
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        { attrs: { transition: "fade-transition" } },
                        [
                          _c("v-lazy", [
                            _c("div", [
                              _vm.arResult.INSTRUCTION
                                ? _c(
                                    "div",
                                    { staticClass: "ins" },
                                    _vm._l(
                                      _vm.arResult.INSTRUCTION,
                                      function (ins) {
                                        return _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: ins.VALUE_FILE.src,
                                              target: "_blank",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                                    " +
                                                _vm._s(ins.VALUE_FILE.name) +
                                                " (" +
                                                _vm._s(
                                                  ins.VALUE_FILE.file_size
                                                ) +
                                                ")\n                                                "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        { attrs: { transition: "fade-transition" } },
                        [
                          _c("v-lazy", [
                            _c(
                              "div",
                              [
                                _c("quick-response", {
                                  attrs: {
                                    "signed-parameters":
                                      _vm.ajaxParams.signedParameters,
                                    token: _vm.ajaxParams.token,
                                    id: this.originalId,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-xl-12" }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xl-3" }, [
            _c("div", { staticClass: "pos-sti old-pr-pos" }, [
              _vm.arResult.PRICE_OLD > 0
                ? _c("div", { staticClass: "old-price-block" }, [
                    _c("del", {
                      staticClass: "dis-pr-old-pr-pos",
                      domProps: {
                        innerHTML: _vm._s(_vm.arResult.FORMAT_PRICE_OLD),
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "dis-pr" }, [
                      _vm._v("-" + _vm._s(_vm.arResult.DISCOUNT_PR) + "%"),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "price-block" }, [
                _c("div", {
                  staticClass: "price",
                  domProps: { innerHTML: _vm._s(_vm.arResult.FORMAT_PRICE) },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "heart-like" }, [
                  _vm.arResult.FAVORITE
                    ? _c(
                        "a",
                        {
                          staticClass: "eh-like-c-s active",
                          attrs: { href: "/favorite/" },
                        },
                        [_c("span")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.arResult.FAVORITE
                    ? _c(
                        "a",
                        {
                          staticClass: "eh-like-c-s",
                          attrs: { href: "" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.addToFavorite(_vm.arResult)
                            },
                          },
                        },
                        [_c("span")]
                      )
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "price-block-basket" }, [
                !_vm.arResult.BASKET && _vm.arResult.ACTIVE == "Y"
                  ? _c(
                      "a",
                      {
                        staticClass: "price-block-basket-b",
                        attrs: { href: "" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.addToBasket(_vm.arResult)
                          },
                        },
                      },
                      [_vm._v("В корзину")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.arResult.BASKET
                  ? _c(
                      "a",
                      {
                        staticClass: "b-pay-detail-debt price-block-basket-b",
                        class: { active: _vm.arResult.BASKET },
                        attrs: { href: "/personal/cart/" },
                      },
                      [
                        _vm._v(
                          " \n                                            Перейти в корзину\n                                        "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.arResult.ACTIVE == "N" && !_vm.subscribeActive
                  ? _c("div", { staticClass: "subscribe" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.subscribeEmail,
                            expression: "subscribeEmail",
                          },
                        ],
                        staticClass: "email-sub",
                        attrs: {
                          type: "email",
                          placeholder: "Ваш e-mail",
                          required: "",
                        },
                        domProps: { value: _vm.subscribeEmail },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.subscribeEmail = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "b-pay-detail-cor-bas subscribe",
                          attrs: { href: "" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.sendSubscribe.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v("Подписаться")]
                      ),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "Как только товар появится у нас в наличии мы вас уведомим"
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.subscribeActive
                  ? _c("div", { staticClass: "subscribe-result" }, [
                      _c("p", [
                        _vm._v(
                          "Спасибо за подписку, как только товар появится в наличии мы с вами свяжемся"
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.arResult.ACTIVE == "Y"
                ? _c("div", { staticClass: "col-vo" }, [
                    _c("span", { staticClass: "col-vo-i" }, [
                      _vm._v("Товар доставим "),
                    ]),
                    _vm._v(" "),
                    _vm.arResult.PROPS.DELIVERY
                      ? _c("b", [
                          _vm._v(
                            _vm._s(_vm.arResult.PROPS.DELIVERY[0].VALUE_TEXT)
                          ),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.arResult.ACTIVE == "Y"
                ? _c("div", { staticClass: "col-vo" }, [
                    _c("span", { staticClass: "col-vo-i" }, [
                      _vm._v("Товар в наличии "),
                    ]),
                    _vm._v(" "),
                    _c("b", [_vm._v("есть")]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.arResult.ACTIVE == "N"
                ? _c("div", { staticClass: "col-vo" }, [
                    _c("span", { staticClass: "col-vo-i out_stock" }, [
                      _vm._v("Нет в наличии "),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("popup-product", { attrs: { item: _vm.addProduct } }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false",
            },
          ],
        },
        [
          _c("div", { staticClass: "hide-form" }, [
            _c("div", { staticClass: "row-flex" }, [
              _c("div", { staticClass: "left-block-img" }, [
                _c("img", {
                  attrs: { src: _vm.arResult.GALLERY.LARGE[0].src, alt: "" },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "left-block-list" }, [
                _c("div", { staticClass: "data-product" }, [
                  _c("div", { staticClass: "title-form" }, [
                    _vm._v(_vm._s(_vm.arResult.NAME)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "price-group" }, [
                    _c("strong", { staticClass: "price" }, [
                      _vm._v(_vm._s(_vm._f("currency")(_vm.priceAfterDis))),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-dis" }, [
                      _c("div", { staticClass: "old_price old-price-block" }, [
                        _c("del", {
                          staticClass: "dis-pr-old-pr-pos old-price-block",
                          domProps: {
                            innerHTML: _vm._s(_vm.arResult.FORMAT_PRICE),
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "dis-pr" }, [_vm._v("10%")]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }